var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncomingMessage = function SvgIncomingMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.37919 15.8333L1.66669 18.75V3.33333C1.66669 3.11232 1.75448 2.90036 1.91076 2.74408C2.06704 2.5878 2.27901 2.5 2.50002 2.5H17.5C17.721 2.5 17.933 2.5878 18.0893 2.74408C18.2456 2.90036 18.3334 3.11232 18.3334 3.33333V15C18.3334 15.221 18.2456 15.433 18.0893 15.5893C17.933 15.7455 17.721 15.8333 17.5 15.8333H5.37919ZM3.33335 15.3208L4.80252 14.1667H16.6667V4.16667H3.33335V15.3208ZM10.8334 9.16667H13.3334L10 12.5L6.66669 9.16667H9.16669V5.83333H10.8334V9.16667Z"
  })));
};
export default SvgIncomingMessage;